import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { hrReportSearchFrom } from '@/features/hr-reports/api'
import { LeaveTakenScreen } from '@/features/hr-reports/leave-taken-screen'
import { hasGrant } from '@/lib/me'
export const Route = createFileRoute('/_authenticated/hr/reports/leave-taken')({
  validateSearch: (s: Record<string, unknown>) => hrReportSearchFrom(s),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'hr_report.view')) throw redirect({ to: '/hr' })
  },
  component: RouteScreen,
})
function RouteScreen() {
  const navigate = useNavigate()
  const search = Route.useSearch()
  return (
    <LeaveTakenScreen
      search={search}
      onSearchChange={(next) => void navigate({ to: '/hr/reports/leave-taken', search: next })}
    />
  )
}
